import React, { useState, useEffect, useMemo } from 'react';
import {
  CircularProgress,
  Box,
  Avatar,
  Typography,
  FormHelperText,
  Autocomplete,
  TextField
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { getAgents } from '../services/userService';

const AgentSelect = ({ value, onChange, disabled = false, label = 'Исполнитель', options }) => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedAgent = useMemo(
    () => agents.find(a => String(a.id) === String(value)) || null,
    [agents, value]
  );

  const defaultFilter = useMemo(() => createFilterOptions(), []);
  const filterOptions = (opts, state) => {
    // Если поле уже заполнено выбранным агентом, при открытии показываем весь список
    if (!state.inputValue) return opts;
    if (selectedAgent && state.inputValue === (selectedAgent.name || '')) return opts;
    return defaultFilter(opts, state);
  };

  useEffect(() => {
    const fetchAgents = async () => {
      setLoading(true);
      try {
        const agentsData = await getAgents();
        setAgents(agentsData);
      } catch (error) {
        console.error('Ошибка при загрузке агентов:', error);
      } finally {
        setLoading(false);
      }
    };

    if (Array.isArray(options) && options.length >= 0) {
      setAgents(options);
      setLoading(false);
    } else {
      fetchAgents();
    }
  }, [options]);

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <FormHelperText sx={{ mb: 0.5, ml: 0, fontWeight: 500 }}>{label}</FormHelperText>
      <Autocomplete
        fullWidth
        disabled={disabled}
        options={agents}
        filterOptions={filterOptions}
        getOptionLabel={(option) => option?.name || ''}
        isOptionEqualToValue={(option, val) => String(option.id) === String(val.id)}
        value={selectedAgent}
        onChange={(event, newValue) => onChange(newValue ? newValue.id : '')}
        loading={loading}
        clearOnBlur={false}
        noOptionsText="Нет вариантов"
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            placeholder="Не назначен"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={16} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar 
              sx={{ 
                width: 24, 
                height: 24, 
                mr: 1, 
                bgcolor: 'primary.main',
                fontSize: '0.8rem'
              }}
            >
              {(option.name || '').charAt(0)}
            </Avatar>
            <Typography>{option.name}</Typography>
            {option.organization && (
              <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                ({option.organization})
              </Typography>
            )}
          </li>
        )}
      />
    </Box>
  );
};

export default AgentSelect;
